import { queryOptions } from '@tanstack/react-query';

import { crownApi } from '@/common/api/crownQueryClient';
import { DepositAccountType } from '@/features/administrator-panel/configuration/product-code-map/ProductCodeMapConfig.tsx';
import { Components } from '@/openapi';

export const getConfigQuery = queryOptions({
  queryFn: async () =>
    (await crownApi.AdminConfiguration_getConfiguration()).data,
  queryKey: ['admin', 'configuration'],
});

export const uploadFileMutationFn = async (file: File) => {
  const fileExtensionReg = /.*\.(.*)/.exec(file.name);
  const { url, publicUrl } = (
    await crownApi.AdminConfiguration_generatePublicFileUploadURL(null, {
      fileExtension: fileExtensionReg ? fileExtensionReg[1] : undefined,
    })
  ).data;

  await window.fetch(url, {
    body: file,
    method: 'PUT',
  });

  return publicUrl;
};

export const getDepositAccountCodeMapConfigQuery = (
  providerId?: string,
  overridesOnly?: boolean,
) =>
  queryOptions({
    queryFn: async () =>
      (
        await crownApi.AdminConfiguration_getDepositAccountCodeConfig({
          providerId,
          overridesOnly: overridesOnly === false ? undefined : overridesOnly,
        })
      ).data,
    queryKey: [
      'admin',
      'deposit-account-code-map-config',
      {
        providerId,
        overridesOnly: overridesOnly === false ? undefined : overridesOnly,
      },
    ],
  });

export const getAvailableDepositAccountCodesQuery = (
  accountType: DepositAccountType,
  providerId?: string,
) => ({
  ...getDepositAccountCodeMapConfigQuery(providerId),
  select: (data: Components.Schemas.GetDepositAccountCodeConfigResponseDto) => {
    const codes = data.availableCodes
      .filter((code) =>
        data.config.some(
          (c) => c.code === code.code && c.accountType === accountType,
        ),
      )
      .map((c) => ({
        ...c,
        providerId: data.config.find((conf) => conf.code === c.code)
          ?.providerId,
      }));

    // If there are provider overrides, return only those codes
    return codes.some((c) => c.providerId)
      ? codes.filter((c) => c.providerId)
      : codes;
  },
});
